import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../context/auth";
import moment from "moment";
import { Link } from "react-router-dom";
import { VerConfiguracion } from "./configuracionGeneral/modalConfigGeneral";
import { CambioClave } from "./modalCambiarClave";
import ButtonNot from "./buttonNotification";
import imgEscudo from "../imagenes/escudo.png";
import comercioService from "./hacienda/actividadEconomica/service/comercio.service";
import { Dimmer } from "./spinner";
import { formatMoneda } from "../util/varios";

function Header2() {
  let op = require("../../src/modulos/datos");
  const factorCambio = JSON.parse(localStorage.getItem('factorCambio'))
  const { user, logout } = useContext(AuthContext);
  const [fechaSistema, setFechaSistema] = useState(
    localStorage.getItem("fechasistema"),
  );
  const efiscaldes = localStorage.getItem("efiscaldes");
  const [usuario, setUsuario] = useState("");
  const [nomOrg, setNomOrg] = useState("");
  const [mostrar, setMostrar] = useState(false);
  const [mostrarClave, setMostrarClave] = useState(false);
  const [escudoError, setEscudoError] = useState(false);
  const [activate, setActivate] = useState(false);
  useEffect(() => {
    let obj = JSON.parse(localStorage.getItem("post"));
    if (obj != null) {
      setFechaSistema(obj.fechasistema);
      setUsuario(obj.login);
      setNomOrg(obj.nombreorg);
    } else {
      setUsuario("");
      setNomOrg("");
    }

    // Manejo del evento de teclado correctamente dentro del useEffect
    const handleKeyDown = (event) => {
      if (event.which === 71) {
        // Tecla 'G'
        setMostrar(true);
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    // Limpieza del evento al desmontar el componente
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  const header = user && (
    <header style={{ width: "100%" }}>
      <nav
        className="navbar navbar-expand navbar-primary navbar-light azulGradiant"
        style={{ marginLeft: 0, color: "#fff", height: "100%", width: "100%" }}
      >
        <ul className="navbar-nav py-0 ml-4">
          <li
            className="nav-item py-0 rounded"
            style={{
              position: "relative",
              width: "80px",
              height: "60px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <img
              src={op.imagenes + "/imagen?img=" + op.logoEscudo}
              // src={imgEscudo}
              onError={() => setEscudoError(true)}
              style={{
                position: "absolute",
                maxHeight: "220px",
                maxWidth: "150px",
                zIndex: 1,
                top: "-10px",
                filter: "drop-shadow(7px -2px 4px rgba(0, 0, 0, 0.8))",
                left: "-30px",
                visibility: escudoError ? "collapse" : "visible",
              }}
            />
          </li>
        </ul>

        {/* --- RESTO DEL NAVBAR --- */}
        <ul className="navbar-nav mx-auto">
          <div className="py-3 titulofiscal fw-bolder pre">
            {nomOrg + " (" + efiscaldes + ")"}
          </div>
        </ul>
        <ul className="navbar-nav ml-auto">
          <div className="py-3 fw-bold text-uppercase">
            Valor Euro €: {formatMoneda(
              factorCambio?.valor?.toString().replace(",", "").replace(".", ","),
              ",",
              ".",
              2
            )}
          </div>
        </ul>
        <ul className="navbar-nav ml-auto">
          <ButtonNot />

          <li className="nav-item">
            <a
              className="nav-link titulofiscal"
              style={{ color: "#ffffff" }}
              onClick={(event) => {
                event.preventDefault();
              }}
              href="#"
            >
              <i className="far fa-calendar-alt">
                {" "}
                {moment.utc(fechaSistema).format("DD/MM/YYYY")}
              </i>
            </a>
          </li>

          <li className="nav-item dropstart">
            <div className="btn-group">
              <a
                className="dropdown-toggle nav-link"
                data-bs-toggle="dropdown"
                aria-expanded="false"
                style={{ color: "#ffffff" }}
                onClick={(event) => {
                  event.preventDefault();
                }}
                href="#"
              >
                <i className="fas fa-user-tie"> {usuario}</i>
              </a>
              <ul className="dropdown-menu">
                <li>
                  <a
                    className="dropdown-item fw-bold bg-light"
                    type="button"
                    onClick={() => {
                      setMostrar(true);
                    }}
                  >
                    Configuración General
                  </a>
                </li>
                <li>
                  <a
                    className="dropdown-item fw-bold bg-light"
                    type="button"
                    onClick={() => {
                      setMostrarClave(true);
                    }}
                  >
                    Cambiar Contraseña
                  </a>
                </li>
              </ul>
            </div>
          </li>
          <Link onClick={logout} className="nav-item" to="/">
            <a className="nav-link text-light botons rounded-pill fw-bold">
              <i className="fas fa-door-open p-1" />
              Salir
            </a>
          </Link>
        </ul>
      </nav>

      <VerConfiguracion
        show={mostrar}
        onHideCancela={() => setMostrar(false)}
      />
      <CambioClave
        show={mostrarClave}
        onHideCancelar={() => setMostrarClave(false)}
        render={() => setMostrarClave(false)}
      />
      <Dimmer active={activate} inverted />
    </header>
  );
  return header;
}

export default Header2;
